import { Box, Chip } from "@mui/material";
import React from "react";

import EnvironmentConfiguration from "../../Constants/EnvironmentConfiguration";

/** The version label which appears at the bottom of the Login screen card. */
const VersionFooter: React.FC = () => {
  const versionFooterLabel = `${EnvironmentConfiguration.app.name ? `${EnvironmentConfiguration.app.name} - ` : ""}v${
    EnvironmentConfiguration.app.version
  }`;

  return (
    <Box display="flex" justifyContent="center">
      <Chip label={versionFooterLabel} />
    </Box>
  );
};

export default VersionFooter;
